export const Section1 = {
	heading: 'How Retailers Can Use Beacon Discovery to Prepare for Newtopia Now',
	content1:
		' is unlike any other industry gathering. With its reimagined format, curated neighborhoods, and a mix of traditional and market-style exhibiting spaces, it offers a dynamic experience for retailers seeking to discover what’s next in natural products.',
	content2:
		'But with so much to see and explore, how can buyers and attendees make the most of their time? Beacon Discovery!',
	content3:
		'Created by New Hope Network, Beacon equips retailers with the tools they need to plan strategically—before they even step onto the show floor. And in 2025, the platform includes more product data than ever before, with integrated maps just like at Expo West!'
};

export const Section2 = {
	heading: 'Discover 24,000+ Products All In One Place ',
	content1: {
		content:
			'Retailers can begin their prep by creating a free Beacon Discovery account. Upon signing up, they’ll select an ingredients template that helps tailor the experience to their unique standards, but templates that can be updated at any time. Every product listed on Beacon meets New Hope Network Standards, offering confidence and consistency. '
	},
	content2: {
		heading: 'Filters allow for highly customized searches based on: ',
		subContent1: {
			heading: 'Region and Distributor Availability:',
			content:
				'Retailers can focus on products they can realistically bring in, eliminating options that aren’t available in their area or through existing partners. '
		},
		subContent2: {
			heading: 'Attributes and Certifications:',
			content:
				'From Clean Label and Plant-Based to USDA Organic and Certified Non-GMO, filters help narrow results to meet customer preferences. '
		},
		subContent3: {
			heading: 'Product Categories and Trends:',
			content:
				'Easily filter by trending categories, diets, or browse core assortments to find fresh, relevant options.'
		}
	},
	content3: {
		content:
			'Each product page includes in-depth details such as manufacturing practices, ingredient sourcing, packaging specs, and pricing formats. Retailers can also explore brand profiles to better understand a company’s story, values, and differentiation all in one place, without toggling between websites. '
	}
};

export const Section3 = {
	heading: 'Favorite and Organize Must-See Products ',
	content1:
		'As retailers explore Beacon Discovery, the “Favorite” feature becomes an essential tool for organizing top product and brand picks. Favoriting helps create a personalized shortlist of must-see exhibitors that can be accessed anytime, anywhere—before, during, and after the event. ',
	subheading: 'Download the show app now for these benefits:',
	content2: {
		boldcontent: 'This favorites list doesn’t just live on the web',
		content:
			'—it connects directly to the Newtopia Now app. When logged in with the same email used for Beacon Discovery, users will see all of their favorites appear as bookmarked booths on the app’s interactive floor plan'
	},
	content3:
		'This integration transforms product research into a physical route. Whether navigating the traditional show floor or exploring the market-style flagship product zone, retailers can move efficiently through the event with clear direction and purpose. It minimizes backtracking, highlights top priorities, and makes the most of every moment at the show. ',
	content4:
		'Favorites can also be shared with team members or downloaded as a CSV to align store buyers on who to visit and what to evaluate. It’s more than just a list—it’s a strategy.'
};

export const Section4 = {
	heading: 'Making Strategic Connections ',
	content1:
		'Beacon Discovery isn’t just about finding new products—it’s a bridge to meaningful conversations. Retailers can review brand stories and values, understand a company’s go-to-market strategy, and reach out in advance to schedule meetings or request samples. ',
	subheading: 'Explore Flagship Products from the Market Now! ',
	content2:
		'Each exhibitor has selected a flagship product to represent their brand. These products are featured prominently in the Market and on Beacon Discovery, offering a curated way to quickly evaluate what makes each brand unique. QR codes in the market help retailers explore new offerings and get essential information quickly. '
};

export const Section5 = {
	heading: 'Pro Tips for Planning ',
	content1: {
		boldcontent: 'Start Early:',
		content:
			' Exhibitors continuously add products to Beacon Discovery in the weeks leading up to the show. By starting early, retailers can identify standout items in advance, prioritize key stops, and reduce decision fatigue once onsite.'
	},
	content2: {
		boldcontent: 'Stay Flexible:',
		content:
			' With new discoveries around every corner, flexibility is key. Beacon Discovery makes it easy to update favorites in real time, ensuring that any exciting new finds can be added to a retailer’s plan during or after the show.'
	},
	content3:
		'With Beacon Discovery, retail buyers and attendees walk into Newtopia Now prepared, focused, and ready to find what’s next. Whether they’re navigating through a themed neighborhood, exploring standout flagship products, or maximizing time in the market-style showcase, Beacon provides the insight and organization needed to turn connections into lasting partnerships. ',
	content4:
		'And with app integration, real-time navigation, and product insights at their fingertips, retailers are no longer overwhelmed—they’re empowered. '
};

export const Section6 = {
	heading: 'What Retailers Can Expect',
	content1:
		'With Beacon Discovery, retail buyers and attendees walk into Newtopia Now prepared, focused, and ready to find what’s next. Whether they’re navigating through a themed neighborhood, exploring standout flagship products, or maximizing time in the market-style showcase, Beacon provides the insight and organization needed to turn connections into lasting partnerships.',
	content2:
		'And with app integration, real-time navigation, and product insights at their fingertips, retailers are no longer overwhelmed—they’re empowered.'
};

export enum Images {
	beaconHome = 'https://s44021.pcdn.co/wp-content/uploads/2025/01/User-BeaconHome-1536x864.png',
	filters = 'https://s44021.pcdn.co/wp-content/uploads/2025/04/Screenshot-2025-04-15-at-10.50.00%E2%80%AFAM.png',
	newtopia = 'https://s44021.pcdn.co/wp-content/uploads/2025/04/1.png',
	poster = 'https://s44021.pcdn.co/wp-content/uploads/2025/04/2.png'
}

export enum Links {
	beaconHome = 'https://beacon.newhope.com/',
	newtopia = 'https://app.newtopianow.com/event/newtopia-2026',
	appstore = 'https://apps.apple.com/in/app/newtopia-now-event-app/id6538719449'
}
